//@flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

import { ItemTagTooltip } from './ItemTagTooltip';
import { ItemTagIndicator } from './ItemTagIndicator';

import { getTooltipDirection } from '../helpers/getTooltipDirection';

import styles from './ItemTag.scss';

import type { ItemTag_tag as TradePhotoTag } from './__generated__/ItemTag_tag.graphql';

type ItemTagProps = {
    tag: ?TradePhotoTag,
    onHover: string => void,
    onClose: () => void,
    isHovered: boolean,
    containerRef: ?Element,
};

export const ItemTagComponent = (props: ItemTagProps) => {
    const tag = props?.tag;
    const tagId = tag?.serviceId;

    if (!tagId) {
        return null;
    }

    const posX = tag?.x;
    const posY = tag?.y;
    const left = `${posX || 0}%`;
    const top = `${posY || 0}%`;

    const tooltipDirection = getTooltipDirection({
        x: posX,
        y: posY,
        containerWidth: props?.containerRef?.current?.clientWidth,
    });

    const _onHover = (event: SyntheticEvent<any>) => {
        event.stopPropagation();
        props.onHover(tagId);
    };

    // istanbul ignore next
    const _mouseLeave = (event: SyntheticMouseEvent<HTMLElement>) => {
        if (props.isHovered) {
            if (event.pageY < event.currentTarget.getBoundingClientRect().top + window.scrollY) {
                return;
            }
            props.onClose();
        }
    };

    return (
        <div
            className={classnames(styles.tag, { [styles.active]: props.isHovered })}
            style={{ left, top }}
            onMouseEnter={_onHover}
            onClick={_onHover}
            onMouseLeave={_mouseLeave}
            data-tn="item-tag"
        >
            <div className={styles.tooltipWrapper} data-tn="item-tag-tooltip-wrapper">
                <ItemTagTooltip
                    tag={(tag: ?Object)}
                    isVisible={props.isHovered}
                    onClose={props.onClose}
                    tooltipDirection={tooltipDirection}
                />
            </div>
            <ItemTagIndicator />
        </div>
    );
};

export const ItemTag = createFragmentContainer(ItemTagComponent, {
    tag: graphql`
        fragment ItemTag_tag on TradePhotoTag {
            ...ItemTagTooltip_tag
            serviceId
            x
            y
        }
    `,
});
